import type { LucideIcon } from 'lucide-react'
import {
  Target,
  Users,
  DollarSign,
  Box,
  Megaphone,
  Swords,
  UserCog,
  Landmark,
  ClipboardCheck,
  Palette,
  Scale,
  Settings,
} from 'lucide-react'
import type { ContextDomain } from '@/types/contextEngine'

export const DOMAIN_ICONS: Record<ContextDomain, LucideIcon> = {
  mission: Target,
  target_market: Users,
  business_model: DollarSign,
  product: Box,
  go_to_market: Megaphone,
  competition: Swords,
  team: UserCog,
  fundraising: Landmark,
  validation: ClipboardCheck,
  brand: Palette,
  legal: Scale,
  operations: Settings,
}
